import React from "react";
import { BackTop } from "antd";
import "./CaliforniaNotice.css";

class CaliforniaNotice extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="constrain">
        <div className="california-container">
          <div className="california-header">
            <h1>CALIFORNIA NOTICES</h1>
            <p className="last-updated">Last Updated: December 2025</p>
          </div>

          <div className="california-content">
            {/* Welcome Section */}
            <section className="california-section welcome-section">
              <p className="welcome-text">Welcome to No Cap Vote!</p>
            </section>

            {/* Table of Contents */}
            <div className="table-of-contents">
              <h2>Table of Contents</h2>
              <ol>
                <li><a href="#section-1">California Consumer Rights Notice</a></li>
                <li><a href="#section-2">Your Rights Under CCPA</a></li>
                <li><a href="#section-3">California Residents Under 18</a></li>
                <li><a href="#section-4">Using an Authorized Agent</a></li>
                <li><a href="#section-5">Privacy Laws of Other States</a></li>
                <li><a href="#section-6">Definitions Under State Privacy Laws</a></li>
                <li><a href="#section-7">Your Rights Under State Privacy Laws</a></li>
                <li><a href="#section-8">Making a Request</a></li>
                <li><a href="#section-9">Contact Information</a></li>
              </ol>
            </div>

            {/* Section 1 */}
            <section id="section-1" className="california-section">
              <h2>1. California Consumer Rights Notice</h2>
              <p>
                Pursuant to California Civil Code Section 1789.3, California residents, under the California Consumer 
                Privacy Act of 2018, ("CCPA"), may request to receive certain disclosures or categories in relation to 
                how we collect, share, and use your Personal Information for business or shared direct marketing (Shine 
                the Light law), or commercial purposes with third parties during the preceding year, once per year, which 
                may include third-party names, addresses, descriptions of the services or products marketed to third 
                parties. Under the CCPA, we collect, disclose, share, or use Sensitive Personal Information for purposes 
                described.
              </p>
              <p>
                Users have the choice to opt in or opt out of{" "}
                <a href="http://www.nocapvote.com/donotsellmypersonalinfo">www.nocapvote.com/donotsellmypersonalinfo</a>{" "}
                of the sale or sharing of your Personal Information or data used by us to third parties at any time.
              </p>
            </section>

            {/* Section 2 */}
            <section id="section-2" className="california-section">
              <h2>2. Your Rights Under CCPA</h2>
              <p>California users may submit a request:</p>
              <ol>
                <li>for Personal Information or records that we may have,</li>
                <li>to opt out, correct, or delete personal information under certain circumstances, and/or</li>
                <li>if you have any questions regarding use of the Services or to resolve a complaint you may have 
                regarding the Services via email at <a href="mailto:notice@nocapvote.com">notice@nocapvote.com</a>.</li>
              </ol>
              <div className="important-notice">
                <p>
                  <strong>Important:</strong> Any requests must be labeled "California Amendment/Records Request" in the 
                  subject field of your email, must include a content description of what you are requesting to be removed 
                  or deleted, as well as the content location information.
                </p>
              </div>
              <p>
                Although the nature of this request may not ensure complete removal from the Internet of the content or 
                information that you publicly posted, we may retain the content as necessary subject to Applicable Laws. 
                Without sufficient information and proper identifying subject descriptions, in relation to your California 
                Amendment/Records Request, we are not responsible for notices that are not labeled or properly delivered, 
                and we may not be able to respond to such a request.
              </p>
              <div className="contact-info-box">
                <h3>Contact California Department of Consumer Affairs</h3>
                <p>You may also contact the Complaint Assistance Unit of the Division of Consumer Services of the 
                California Department of Consumer Affairs:</p>
                <ul>
                  <li><strong>Online:</strong>{" "}
                    <a href="http://www.dca.ca.gov/webapps/gencomplaint.php" target="_blank" rel="noopener noreferrer">
                      www.dca.ca.gov/webapps/gencomplaint.php
                    </a>
                  </li>
                  <li><strong>Address:</strong> 1625 North Market Boulevard, Suite S-202, Sacramento, California 95834</li>
                  <li><strong>Phone:</strong> 916.445.1254 or 800.952.5210</li>
                </ul>
              </div>
            </section>

            {/* Section 3 */}
            <section id="section-3" className="california-section">
              <h2>3. California Residents Under 18</h2>
              <p>
                California residents under the age of 18 and are registered users of the Services where this policy is 
                posted may request removal of User Content you publicly posted by contacting us at{" "}
                <a href="mailto:notice@nocapvote.com">notice@nocapvote.com</a>.
              </p>
              <div className="important-notice">
                <p>
                  <strong>Important:</strong> Any requests must be labeled "California Eraser Request" in the subject 
                  field of your email, must include a content description of what you are requesting to be removed or 
                  deleted, as well as the content location information.
                </p>
              </div>
              <p>
                Although the nature of this request may not ensure complete removal from the Internet of the content or 
                information that you publicly posted, we may retain the content as necessary subject to Applicable Laws. 
                Without sufficient information and proper identifying subject descriptions, in relation to your California 
                Eraser Request, we are not responsible for notices that are not labeled or properly delivered, and we may 
                not be able to respond to such a request.
              </p>
            </section>

            {/* Section 4 */}
            <section id="section-4" className="california-section">
              <h2>4. Using an Authorized Agent</h2>
              <p>
                Should you choose to retain an agent, on your behalf, to make a request to exercise your rights under the 
                CCPA, your authorized agent must provide, or email, with valid written authority executed by you to make 
                such a request. We may contact you for further information or identity verification before responding to 
                such a request.
              </p>
            </section>

            <div className="section-divider">
              <h3>OTHER STATE PRIVACY LAWS</h3>
            </div>

            {/* Section 5 */}
            <section id="section-5" className="california-section">
              <h2>5. Privacy Laws of Other States</h2>
              <p>
                Consumers in Colorado, Connecticut, Delaware, Florida, Virginia, and other states may have similar privacy 
                laws and certain rights regarding the Personal Information that was collected, processed, used, disclosed, 
                and/or sold. Subject to Applicable Laws and where you reside, we may not have collected, processed, used, 
                disclosed, or "sold" your Personal Information for targeted advertising or selling.
              </p>
            </section>

            {/* Section 6 */}
            <section id="section-6" className="california-section">
              <h2>6. Definitions Under State Privacy Laws</h2>
              <p>
                Under the Colorado Privacy Act, ("CPA"), and the Connecticut Data Privacy Act (the "CDPA"), use of your 
                Personal Information to provide online advertisements to your Devices that may be of interest to you is 
                categorized as "sold."
              </p>
              <p>
                Under the Virginia Consumer Data Protection Act, ("VCDPA"), including the CPA and the CDPA, the use of 
                your Personal Information to provide online advertisements to your Devices that may be of interest to you 
                is categorized as "targeted advertising."
              </p>
              <p>
                Under the VCDPA, and other states with similar privacy laws, "sale" is defined as the exchange of 
                information for monetary consideration; however, this excludes the transfer of Personal Information as an 
                asset which may be part of a bankruptcy, merger or similar transactions relating to a business. Under the 
                CPA and the CDPA, "sale" is defined as delivering online advertisements to you on your Devices that may 
                meet your needs, interests, and preferences. Further, the definition of "sale," under state privacy laws, 
                does not include the transfer of Personal Information as an asset that is part of a bankruptcy, merger or 
                similar transactions relating to a business.
              </p>
            </section>

            {/* Section 7 */}
            <section id="section-7" className="california-section">
              <h2>7. Your Rights Under State Privacy Laws</h2>
              <p>
                In California, Colorado, Connecticut, Delaware, Florida, Indiana, Iowa, Montana, Oregon, Tennessee, Texas, 
                Nevada, and Utah, your right to access, portability of data, delete, correct, nondiscrimination, and 
                appeal, subject to certain exceptions, is defined as:
              </p>
              <ul className="rights-list">
                <li>
                  <strong>Right to access and portability of data:</strong> is the right to request for Personal 
                  Information or records that we may have about you, including in a portable form, that may be in a 
                  working format. We may contact you for further information or identity verification before responding 
                  to such a request to disclose how, what, or why we collected, processed, used, disclosed, and/or sold 
                  your Personal Information, including, with whom we shared such information;
                </li>
                <li>
                  <strong>Right to delete:</strong> is the right to request to delete your Personal Information that we 
                  collected from you. We may contact you for further information or identity verification before 
                  responding to such a request to delete your Personal Information;
                </li>
                <li>
                  <strong>Right to correct:</strong> is the right to request to correct inaccurate Personal Information 
                  that we collected from you. We may contact you for further information or identity verification before 
                  responding to such a request to correct your Personal Information;
                </li>
                <li>
                  <strong>Right to nondiscrimination:</strong> is the right to be free from unlawful discriminatory 
                  treatment for exercising your rights; and
                </li>
                <li>
                  <strong>Right to appeal:</strong> is the right request an appeal if we are not able to comply with your 
                  request by contacting us at <a href="mailto:notice@nocapvote.com">notice@nocapvote.com</a>.
                </li>
              </ul>
            </section>

            {/* Section 8 */}
            <section id="section-8" className="california-section">
              <h2>8. Making a Request</h2>
              <p>
                If you are making this request, please contact us at{" "}
                <a href="mailto:notice@nocapvote.com">notice@nocapvote.com</a>.
              </p>
              <div className="important-notice">
                <p>
                  <strong>Important:</strong> Any requests must be labeled "Amendment/Records Request" in the subject 
                  field of your email, must include a content description of what you are requesting to be removed or 
                  deleted, as well as the content location information.
                </p>
              </div>
              <p>
                Although the nature of this request may not ensure complete removal from the Internet of the content or 
                information that you publicly posted, we may retain the content as necessary subject to Applicable Laws. 
                Without sufficient information and proper identifying subject descriptions, in relation to your 
                Amendment/Records Request, we are not responsible for notices that are not labeled or properly delivered, 
                and we may not be able to respond to such a request.
              </p>
              <p>
                Should you choose to designate an agent, on your behalf, to make a request to exercise your rights, your 
                authorized agent must provide, or email, with valid written authority executed by you to make such a 
                request. We may contact you for further information or identity verification before responding to such a 
                request within 45 days of receipt of the request.
              </p>
              <div className="warning-notice">
                <p>
                  <strong>Please Note:</strong> At our sole discretion, we may refuse, decline, delete, suspend, or 
                  discontinue your request for requests or access to Your Account due to varying reasons, including, but 
                  not limited to, legal requirements or obligations, invalid identity verification, security breach, 
                  ineligibility, improper conduct, lack of information required, and other sensitive reasons. Please read 
                  and review our <a href="/communityguidelines">Community Guidelines</a>.
                </p>
              </div>
            </section>

            {/* Section 9 */}
            <section id="section-9" className="california-section contact-section">
              <h2>9. Contact Information</h2>
              <p>
                If you have any questions, or need further assistance, please contact No Cap Vote at{" "}
                <a href="mailto:notice@nocapvote.com">notice@nocapvote.com</a>.
              </p>
            </section>
          </div>
        </div>
        <BackTop />
      </div>
    );
  }
}

export default CaliforniaNotice;